module.exports = "/images/blueInfo.svg?416d816435f05c48710eeba04cd0be23";